import script from "./CommentsListContent.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentsListContent.vue?vue&type=script&setup=true&lang=js"

import "./CommentsListContent.vue?vue&type=style&index=0&id=785fff3e&lang=scss"

const __exports__ = script;

export default __exports__